export default "__VITE_ASSET__C5bG8vw9__"